import { Button, Tooltip } from "antd";
import { useRef } from "react";
import { RiAttachment2 } from "react-icons/ri";
import { v4 as uuidv4 } from "uuid";
import { MAX_FILE_SIZE, exceedFiles, imagesTypes } from "../../config/Constant";
import { useUploadFileStore } from "../../store/UploadFileStore";
import { useInfoUser } from "../../store/UserStore";
import { openNotificationError } from "../../utils/Utils";

const FileSending = ({ formData, setFormData, id }) => {
  const fileInputRef = useRef(null);
  const { uploadFiles, setUploadFiles } = useUploadFileStore();
  const { languageMap } = useInfoUser();

  const handleFileChange = (e) => {
    let totalSizeUpload = 0;

    const files = Array.from(e?.target?.files)?.filter(
      (file) => file?.size !== 0,
    );

    if (files?.length > exceedFiles + 1) {
      openNotificationError(
        languageMap?.["error.exceed.fileNumber"] ??
          "The number of files exceeds 24",
      );
      return;
    }

    files?.forEach((file) => {
      totalSizeUpload += file?.size;
    });

    if (totalSizeUpload > MAX_FILE_SIZE) {
      openNotificationError("File size exceeds the 1gb limit");
      return;
    }

    const text = formData.text;
    const filesArray = files.map((file) => {
      file.uid = uuidv4();
      return file;
    });
    let mediaFiles = [];
    let encodePhotos = [];

    filesArray?.forEach((file) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = (r) => {
        if (imagesTypes.includes(file?.type)) {
          const img = new Image();

          img.src = r?.target?.result;

          img.onload = () => {
            file.width = img.width;
            file.height = img.height;
          };

          img.onerror = () => {
            console.error("Image loading failed");
          };
        } else {
          mediaFiles.push(file);
        }

        setFormData({
          text: text,
          files: filesArray,
          mediaFiles: mediaFiles,
          encodePhotos: encodePhotos,
        });

        setUploadFiles([...uploadFiles, ...(mediaFiles || [])]);
      };
    });

    e.target.value = null;
  };

  const handleButtonClick = () => {
    fileInputRef?.current?.click();
  };

  return (
    <label htmlFor={id}>
      <Tooltip
        placement="top"
        title={
          languageMap?.["modal.conversation.selectAttach"] ??
          "Select attachments"
        }
        color={"#0091ff"}
      >
        <Button
          onClick={handleButtonClick}
          className="bg-[#2a56b9] text-[white]"
          icon={<RiAttachment2 className="text-[18px]" />}
        />
      </Tooltip>
      <input
        multiple
        type="file"
        id={id}
        ref={fileInputRef}
        className="hidden"
        onChange={handleFileChange}
      />
    </label>
  );
};

export { FileSending };
